export default function isListPopulated(list) {
  if (!list) {
    return false;
  }
  return list.length > 0;
}
